<template>
  <div class="home">
    <!-- Hero Section -->
    <section id="hero" class="hero section light-background">
      <div class="container">
        <div class="row gy-4 justify-content-center justify-content-lg-between">
          <div
            class="col-lg-5 order-2 order-lg-1 d-flex flex-column justify-content-center"
          >
            <!-- The multi-script wordmark stays untranslated in every locale. -->
            <h1 data-aos="fade-up">தமிழ் 𑀢𑀫𑀺𑀵𑁆</h1>
            <HelloWorld />

            <div class="d-flex" data-aos="fade-up" data-aos-delay="200">
              <a href="/tamil-data-decentralization" class="btn-get-started">
                {{ $t("home.hero.cta") }}
              </a>
            </div>
          </div>
          <div class="col-lg-5 order-1 order-lg-2 hero-img" data-aos="zoom-out">
            <img
              src="assets/img/home-tamildata.png"
              class="img-fluid animated"
              :alt="$t('common.subTagline')"
            />
          </div>
        </div>
      </div>
    </section>
    <!-- /Hero Section -->
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "HomeView",
  components: {
    HelloWorld,
  },
};
</script>
